import { api } from './api';

export interface PageData {
  id: number;
  siteId: number;
  tenantId: number;
  url: string;
  title?: string;
  canonicalUrl?: string;
  isActive: boolean;
  firstSeenAt: string;
  lastSeenAt: string;
  discoveredFrom: string[];
  lastSeenInGsc?: string;
  lastSeenInBing?: string;
  lastSeenInGa4?: string;
  createdAt: string;
  updatedAt: string;
}

export interface PagedResult<T> {
  content: T[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
}

export interface GetPagesParams {
  siteId?: number;
  tenantId?: number;
  isActive?: boolean;
  source?: 'GSC' | 'BING' | 'GA4';
  search?: string;
  page?: number;
  size?: number;
  sortBy?: string;
  sortDirection?: 'ASC' | 'DESC';
}

export const pagesService = {
  /**
   * Get all pages with optional filtering and pagination
   */
  async getAllPages(params: GetPagesParams): Promise<PagedResult<PageData>> {
    const response = await api.get<{ data: PagedResult<PageData> }>(
      '/coreapi/pages',
      { params }
    );
    return response.data.data;
  },

  /**
   * Get page by ID
   */
  async getPageById(id: number): Promise<PageData> {
    const response = await api.get<{ data: PageData }>(
      `/coreapi/pages/${id}`
    );
    return response.data.data;
  },

  /**
   * Get pages for a specific site
   */
  async getPagesBySite(siteId: number): Promise<PageData[]> {
    const response = await api.get<{ data: PageData[] }>(
      `/coreapi/pages/site/${siteId}`
    );
    return response.data.data;
  },
};
